import { render, staticRenderFns } from "./SedeUniversidadLayout.vue?vue&type=template&id=e5b48b14&scoped=true"
import script from "./SedeUniversidadLayout.vue?vue&type=script&lang=js"
export * from "./SedeUniversidadLayout.vue?vue&type=script&lang=js"
import style0 from "./SedeUniversidadLayout.vue?vue&type=style&index=0&id=e5b48b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b48b14",
  null
  
)

export default component.exports